import { KeyValuePair } from "../key-value-pair";

export class ReimbursementConstants {

    public static RENTAL: string = "Rental";
    public static TOWING: string = "Towing";

    public static ReimbursementTypes: KeyValuePair[] = [
        {key: this.RENTAL, value: this.RENTAL},
        {key: this.TOWING, value: this.TOWING}
    ]
}